import React, { useState } from "react";
import { Layout } from "antd";
import Sidebar from "../../components/Sidebar/Sidebar";
import AppHeader from "../../components/Header/Header";
import AppFooter from "../../components/Footer/Footer";
import TokenExpirationChecker from "../Common/TokenExpirationChecker";
import styles from "./AdminLayout.module.scss";

const { Sider, Content } = Layout;

const AdminLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  const handleToggle = () => {
    setCollapsed(!collapsed);
  };

  return (
    <Layout className={styles.adminLayout}>
      {/* Token Expiration Checker */}
      <TokenExpirationChecker />

      {/* Sidebar */}
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        breakpoint="lg"
        collapsedWidth={64}
        width={240}
        className={styles.sidebar}
        theme="dark"
      >
        <Sidebar />
      </Sider>

      <Layout className={`${styles.mainContent} ${collapsed ? styles.collapsed : ''}`}>
        {/* Header */}
        <AppHeader onToggle={handleToggle} collapsed={collapsed} />

        {/* Main Content */}
        <Content className={styles.contentArea}>
          {children}
        </Content>

        {/* Footer */}
        <AppFooter />
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
